import { createContext, useContext } from 'react';

/**
 * Carries useUpgradeFlow's surface — firmware URL lists, per-family selections,
 * per-board in-progress flags and slot state — from App to the cards that use
 * it, instead of threading it through <DeviceView> as props.
 *
 * It was 49 props of the 65 on that element: two thirds of the component's
 * surface for one feature. Phase 4 reduced the site to ~23 and deliberately
 * left useUpgradeFlow out of scope; the firmware rework (PR #110) then doubled
 * exactly that part, and the slot fixes added eight more.
 *
 * The provider is given the hook's return value directly, so there is no
 * adapter layer to drift: whatever useUpgradeFlow returns is what consumers
 * see, under the hook's own names.
 */
const UpgradeContext = createContext(undefined);

export function UpgradeProvider({ value, children }) {
  return <UpgradeContext.Provider value={value}>{children}</UpgradeContext.Provider>;
}

export function useUpgradeContext() {
  const ctx = useContext(UpgradeContext);
  if (ctx === undefined) {
    throw new Error('useUpgradeContext must be used within an UpgradeProvider');
  }
  return ctx;
}
